import { css } from "@compiled/react";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";

import { media } from "@atlaskit/primitives/responsive";

import { collectionAboutSectionRelayFragment$key } from "@/__generated__/collectionAboutSectionRelayFragment.graphql";

interface CollectionAboutSectionProps {
    collection: collectionAboutSectionRelayFragment$key;
}

const collectionAboutTitle = css({
    "fontSize": "2.25rem",
    "lineHeight": "2.75rem",
    "fontWeight": 500,
    "letterSpacing": 0.3,
    "color": "#1d3059",
    "margin": 0,

    "@media (max-width: 47.99rem)": {
        fontSize: "1.5rem",
        lineHeight: "1.75rem"
    }
});

const collectionAboutWrapper = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBlockStart: 64,
    gap: 24,

    [media.below.sm]: {
        flexDirection: "column"
    }
});

const collectionAboutInfo = css({
    display: "flex",
    gap: 40,
    flexDirection: "column",
    textAlign: "left"
});

const collectionAboutStyle = css({
    margin: 0
});

const aboutImage = css({
    maxWidth: 328,
    maxHeight: 200
});

const CollectionAboutSectionRelayFragment = graphql`
    fragment collectionAboutSectionRelayFragment on ContentPlatformTemplateCollection {
        name
        aboutThisCollectionHeader
        aboutThisCollection
        aboutThisCollectionImage {
            url
            name: title
        }
    }
`;

export const CollectionAboutSection = ({
    collection
}: CollectionAboutSectionProps) => {
    const {
        name,
        aboutThisCollectionHeader,
        aboutThisCollection,
        aboutThisCollectionImage
    } = useFragment(CollectionAboutSectionRelayFragment, collection);

    return (
        <section css={collectionAboutWrapper}>
            <div css={collectionAboutInfo}>
                <h2 css={collectionAboutTitle}>{aboutThisCollectionHeader}</h2>
                <p css={collectionAboutStyle}>{aboutThisCollection}</p>
            </div>
            {aboutThisCollectionImage && (
                // eslint-disable-next-line no-restricted-syntax
                <img
                    css={aboutImage}
                    src={aboutThisCollectionImage.url}
                    alt={name ?? aboutThisCollectionImage.name ?? undefined}
                />
            )}
        </section>
    );
};
